<template>
  <form
    class="ask-chat-form"
    @submit.prevent="submitForm"
  >
    <textarea
      v-model="message"
      class="stk-input ask-input"
      placeholder="Ask me anything about clients, portfolios, meetings, documents…"
      rows="4"
      @keydown="handleInput"
    />

    <IconButton
      class="ask-send"
      icon="fas fa-paper-plane"
      :disabled="message.trim() === ''"
    />
  </form>
</template>

<script setup>
import { ref } from 'vue';
import { useChatStore } from '@frontend/ui/stores/chatStore';
import { IconButton } from '@stakeui';

const chatStore = useChatStore();

const message = ref('');

const handleInput = (event) => {
  if (event.key === 'Enter' && !event.shiftKey) {
    event.preventDefault();
    submitForm();
  }
}

const submitForm = async () => {
  if (!message.value) {
    return;
  }

  chatStore.sendMessage({ text: message.value, role: 'user' }, '', '');
  message.value = '';
};
</script>

<style scoped>
.ask-chat-form {
  display: flex;
  position: relative;
}

.ask-input {
  --stk-control-focus-border-color: var(--stk-ai-pink);
  --stk-control-focus-outline-color: hsl(var(--stk-ai-pink-h) var(--stk-ai-pink-s) var(--stk-ai-pink-l) / 20%);
  padding-right: 2em;
  resize: none;
}

.ask-send {
  border-radius: 0.25em;
  color: var(--stk-ai-pink);
  padding: 1em;
  position: absolute;
  right: 0.5em;
  top: 0.5em;

  &:hover {
    background-color: hsl(var(--stk-ai-pink-h), var(--stk-ai-pink-s), 95%);
  }

  &[disabled] {
    color: var(--stk-text-weak);
    opacity: 0.5;
    pointer-events: none;
  }
}
</style>
